import React, { FC } from 'react';
import { observer } from 'mobx-react';

import { FormEntryNew } from 'controls/react/form/formEntryNew';
import { AccountSelector } from 'controls/react/accountSelector';
import { ApplicationState } from 'framework/applicationState';
import { useStore } from 'core/react/useStore';
import { translator } from 'core/localization';
import { DataSourceSelector } from 'controls/designer/features/widgets/datasources/shared/components/data-source-selector/dataSourceSelector';
import { DataSourceRowEditor } from 'controls/designer/features/widgets/datasources/shared/components/data-source-row-editor/dataSourceRowEditor';
import { DatasourceEditorStore } from './datasourceEditorStore';
import { DatasourceEditorProps } from './types';

const i18n = translator({
	'Account': {
		no: 'Konto',
	},
	'Datasource': {
		no: 'Datakilde',
	},
	'Datasource row': {
		no: 'Datakilderad',
	},
});

export const DatasourceEditor: FC<DatasourceEditorProps> = observer((props) => {
	const store = useStore(() => new DatasourceEditorStore(), { props });
	const { manager, showRowEditor } = props;

	return (
		<>
			<FormEntryNew
				label={i18n('Account')}
				model={manager.config.selection}
				modelField={'dataSourceSelectorAccountId'}
				alwaysWithValue={true}
			>
				<AccountSelector accountId={ApplicationState.userAccountId} withSharedDatasourceOption={true} />
			</FormEntryNew>
			<FormEntryNew label={i18n('Datasource')} model={manager.config.selection} modelField={'dataSourceId'}>
				<DataSourceSelector manager={manager} options={store.dataSourceOptions} />
			</FormEntryNew>
			{showRowEditor && (
				<FormEntryNew label={i18n('Datasource row')} alwaysWithValue={true}>
					<DataSourceRowEditor manager={manager} />
				</FormEntryNew>
			)}
		</>
	);
});
